import React from 'react';
import PropTypes from 'prop-types';

import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';

import AddLeaderForm from '../../containers/AddLeaderForm';

class AddLeaderBtn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
    };
  }

  openModal = () => {
    // const { isModalOpen } = this.state;
    // console.log('AddLeaderBtn: openModal: isModalOpen=', isModalOpen);
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    // const { isModalOpen } = this.state;
    // console.log('AddLeaderBtn: closeModal: isModalOpen=', isModalOpen);
    this.setState({ isModalOpen: false });
  };

  toggleModal = () => {
    this.setState(state => ({
      isModalOpen: !state.isModalOpen,
    }));
  };

  handleAfterSubmit = () => {
    const { afterChange } = this.props;
    this.closeModal();
    afterChange();
  };

  renderModal() {
    const { run, gameSlug } = this.props;
    const { isModalOpen } = this.state;

    return (
      <Modal isOpen={isModalOpen} toggle={this.toggleModal}>
        <ModalHeader toggle={this.toggleModal}>
          <span>Add Leader to Run</span>
        </ModalHeader>
        <ModalBody className="text-center">
          <AddLeaderForm
            run={run}
            gameSlug={gameSlug}
            afterSubmit={this.handleAfterSubmit}
          />
        </ModalBody>
      </Modal>
    );
  }

  render() {
    return (
      <div>
        <Button className="btn btn-bay-blue" onClick={this.openModal}>
          Add Leader
        </Button>
        {this.renderModal()}
      </div>
    );
  }
}

AddLeaderBtn.propTypes = {
  run: PropTypes.object.isRequired,
  gameSlug: PropTypes.string.isRequired,
  afterChange: PropTypes.func.isRequired,
};

export default AddLeaderBtn;
